<template>
    <div class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-4 px-3 px-lg-0 my-3 my-lg-0 pt-5">
        <div class="col-12 d-flex flex-wrap justify-content-center align-items-center align-content-center px-2 px-lg-5 overflow-hidden mt-lg-5 pt-5">

<!-- FLOW -->
<router-link to="/flow" custom v-slot="{ navigate }">
  <div 
    @click="navigate"
    class="col-lg-3 col-6 d-flex justify-content-center text-center align-items-center flex-wrap px-5 my-3 my-lg-0 vanish"
    style="cursor: pointer;"
  >
    <img :src="a9" class="img-fluid w-100 vanish" />
  </div>
</router-link>

<!-- ORDER -->
<router-link to="/order" custom v-slot="{ navigate }">
  <div
    @click="navigate"
    class="col-lg-3 col-6 d-flex justify-content-center text-center align-items-center flex-wrap px-5 my-3 my-lg-0"
    style="cursor: pointer;"
  >
    <img :src="a11" class="img-fluid w-100 vanish" />
  </div>
</router-link>

<!-- INTEL -->
<router-link to="/intel" custom v-slot="{ navigate }">
  <div
    @click="navigate"
    class="col-lg-3 col-6 d-flex justify-content-center text-center align-items-center flex-wrap px-5 my-3 my-lg-0"
    style="cursor: pointer;"
  >
    <img :src="a10" class="img-fluid w-100 vanish" />
  </div>
</router-link>

<!-- REWARD -->
<router-link to="/reward" custom v-slot="{ navigate }">
  <div
    @click="navigate"
    class="col-lg-3 col-6 d-flex justify-content-center text-center align-items-center flex-wrap px-5 my-3 my-lg-0"
    style="cursor: pointer;"
  >
    <img :src="a12" class="img-fluid w-100 vanish" />
  </div>
</router-link>

</div>

        <div
            class="col-12 d-flex flex-wrap justify-content-center align-items-center align-content-center px-2 px-lg-5 overflow-hidden pt-5 mt-5">
            <span class="font- fuente-posm label-1 d-flex flex-wrap pt-5 mt-5">Nuestros Principales Sistemas</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'page2',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a9: require('@/assets/images/a9.webp'),
            a10: require('@/assets/images/a10.webp'),
            a11: require('@/assets/images/a12.webp'),
            a12: require('@/assets/images/a11.webp'),
        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        }
    },
}
</script>
<style lang="css" scoped>
.cubeSpace {
    overflow: hidden;
    height: auto;
    width: 100vw;
    height: 100vh;
}

/* @media (max-width: 590px) {
  .vanish {
    display: none;
  }
} */


.label-1 {
    color: var(--color-2);
    font-size: 50px;
    line-height: 1.1;
}

.label-2 {
    color: var(--color-1);
    font-size: 24px;
    line-height: 1.1;
    max-width: 700px;
}

.label-3 {
    color: var(--color-3);
    font-size: 25px;
    line-height: 1.1;
}

.label-4 {
    color: var(--color-1);
    font-size: 24px;
    line-height: 1.1;
}

.margen-negativo {
    /* padding-top: -500px ; */
    /* margin-top: -100px ; */
}

@media (max-width: 992px) and (min-width: 768px) {
    .label-1 {
        font-size: 40px;
    }

    .label-2 {
        font-size: 22px;
    }

    .label-3 {
        font-size: 23px;
    }

    .label-4 {
        font-size: 22px;
    }
}

@media (max-width: 767px) and (min-width: 0) {
    .label-1 {
        font-size: 34px;
    }

    .label-2 {
        font-size: 14px;
    }

    .label-3 {
        font-size: 15px;
    }

    .label-4 {
        font-size: 14px;
    }
}

@media screen and (max-width: 550px) {
    .vanish {
        display: none;
    }
}
</style>